<ng-container [formGroup]="formGroupCampaign">
    <app-mdb-switch label="Hide option for donor to cover Fee" formControlName="hideCoverFee"></app-mdb-switch>
    <div class="divider"></div>
    <app-mdb-switch label="Make default state for cover fee unchecked" formControlName="coverFeeDefaultOff"></app-mdb-switch>
    <div class="divider"></div>
    <app-mdb-switch label="Set custom text for cover fee appeal" formControlName="donorFeeTextCheck"></app-mdb-switch>
    <div class="w-100" style="padding-left: 44px;" *ngIf="formGroupCampaign.value.donorFeeTextCheck">
        <mdb-form-control class="form-fill" data-panel="coverFee">
            <app-mdbp-input mdbInput formControlName="coverFeeText" data-panel="coverFee" label='Cover fee text'></app-mdbp-input>
            <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.coverFeeText.hasError('required') && formGroupCampaign.controls.coverFeeText.touched ">Please provide Cover Fee Text</mdb-error>
        </mdb-form-control>
    </div>
</ng-container>